






















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { CURRENCY_FORMAT } from '@/helpers/currency';
import cCard from '@/components/default/Card.vue';
import cDatagrid from '@/components/default/Datagrid.vue';

import notificationService from '@/services/notificationService';
import contactsRepository from '@/services/contactsRepository';

import $ from 'jquery';

@Component({
    components: {
        cCard,
        cDatagrid,
    },
})
export default class ContactPricingAgreementCard extends Vue {
    @Prop({required: true})
    public contactId!: string;

    private showAll: boolean = false;
    private shownAgreements: IPricingAgreementDtu[] = [];
    private agreements: IPricingAgreementDtu[] = [];
    private loading: boolean = false;

    private mounted() {
        this.loadData();
    }

    private async loadData() {
        try {
            this.loading = true;
            this.agreements = (await contactsRepository.getPricingAgreements(this.contactId)).data;
            this.onShowAllChange();
        } catch (err) {
            notificationService.showAxiosError(err);
        } finally {
            this.loading = false;
        }
    }

    private saveUpdates(e: any) {
        const self = this;
        e.cancel = new Promise(async (resolve, reject) => {
            try {
                await contactsRepository.postPricingAgreement(this.contactId, e.data);
                this.loadData();
                resolve(false);
            } catch (err) {
                notificationService.showAxiosError(err);
                resolve(true);
            }
        });
    }

    private removeAgreement(e: any) {
        const self = this;
        e.cancel = new Promise(async (resolve, reject) => {
            try {
                await contactsRepository.RemovePricingAgreement(this.contactId, e.data);
                this.loadData();
                resolve(false);
            } catch (err) {
                notificationService.showAxiosError(err);
                resolve(true);
            }
        });
    }

    get articles() {
        return this.$store.getters['articles/items'];
    }

    get columns() {
        const self = this;
        const cols: any[] = [
            {
                dataField: 'articleId',
                caption: this.$t('objects.contactPricingAgreement.fields.Article'),
                lookup: {
                    dataSource: self.articles,
                    valueExpr: 'id',
                    displayExpr: 'name',
                },
                allowEditing: false,
            },
            {
                dataField: 'variant',
                caption: this.$t('objects.contactPricingAgreement.fields.Variant'),
                allowEditing: false,
            },
            {
                dataField: 'projectType',
                caption: this.$t('objects.contactPricingAgreement.fields.Type'),
                allowEditing: false,
            },
            {
                dataField: 'custom',
                caption: this.$t('objects.contactPricingAgreement.fields.Custom'),
                allowEditing: false,
            },
            {
                dataField: 'price',
                caption: this.$t('objects.contactPricingAgreement.fields.Price'),
                format: CURRENCY_FORMAT,
                cellTemplate: (cellElement: any, cellInfo: any) => {
                    $(cellElement).append(`<div>${cellInfo.text}</div>`);
                    if (cellInfo.data.price > cellInfo.data.target) {
                        $(cellElement).css('color', 'green');
                    } else if (cellInfo.data.price < cellInfo.data.target) {
                        $(cellElement).css('color', 'red');
                    }
                },
                alignment: 'left',
            },
            {
                dataField: 'target',
                caption: this.$t('objects.subcontractors.labourAgreement.fields.Target'),
                format: CURRENCY_FORMAT,
                alignment: 'left',
                allowEditing: false,
            },
            {
                type: 'buttons',
                buttons: [
                    'edit',
                    {
                        icon: 'fas fa-trash',
                        onClick: (e: any) => {
                            // do sth
                            e.component.deleteRow(e.row.rowIndex);
                        },
                        visible: (e: any) => {
                            if (e.row.isEditing) {
                                return false;
                            }
                            return e.row.data.custom;
                        },
                    },
                ],
            },
        ];

        return cols;
    }

    @Watch('showAll')
    private onShowAllChange() {
        if (this.showAll) {
            this.shownAgreements = this.agreements;
        } else {
            this.shownAgreements = this.agreements.filter((o: IPricingAgreementDtu) => o.custom === true);
        }
    }
}
